import * as types from './mutation_types'

export default {
  [types.USERDATA_SHOW_RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null
    })
  },

  [types.USERDATA_SHOW_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.USERDATA_SHOW_SET_RETRIEVED] (state, retrieved) {
    Object.assign(state, { retrieved })
  },

  [types.USERDATA_SHOW_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  }

}
